<template>
  <div>
    <el-dialog append-to-body :title="title" :visible.sync="dialogVisible" width="700px" :before-close="handleClose"
               @close="handleClose"
               v-if="dialogVisible">
      <div class="flex-center-between account-item pointer" v-for="(item, index) in accountData" :key="index"
           @click="handleLogin(item)">
        <div>{{ item.name || item.deptName.split('|')[0] }}</div>
        <div class="flex-center">
          <img class="mr15" v-if="item.type == 1" src="@/assets/user/icon-account-person.png" alt/>
          <!-- <img v-if="item.type==2" src alt /> -->
          <i class="el-icon-right"></i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import Cookie from "js-cookie";

export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      accountData: []
    };
  },
  methods: {
    show(title) {
      this.title = title
      this.accountData = JSON.parse(this.$auth.getKqAccount())
      this.dialogVisible = true;
    },
    handleLogin(param) {
      Cookie.set("orgCode", param.orgCode);
      let params = {
        orgCode: param.orgCode
      }
      this.$http.get(this.$api.customerEnterprise.chooseKqDept, params).then(res => {
        if (res.data.code == 200) {
          this.handleClose()
          Cookie.set("agency", param.agency)
          location.reload()
        } else {
          this.$message.error(res.data.msg);
        }
        // this.$auth.setToken(res.data.token);
        // this.getInfo(params.spaceType)
      })
      // this.$auth.setUserId(res.data.user.userId);
    },
    getInfo() {
      this.$http.get(this.$api.customerEnterprise.getInfo).then(res => {
        //判断登录类型是个人还是企业，用户账户信息中基本信息的展示
        let temp = res.data.data
        this.handleClose()
        this.$router.push({
          path: "/customerEnterprise/home",
        });
      })
    },
    handleClose() {
      this.loading = false;
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.account-item {
  padding: 15px 20px 15px 10px;
  border-bottom: 1px solid #eee;
  // &:hover {
  //   color: #407fff;
  //   background: #407fff;
  //   opacity: 0.1;
  // }
}

::v-deep .el-dialog__header {
  text-align: center !important;
}
</style>
